import { render, staticRenderFns } from "./NewsListView.vue?vue&type=template&id=a0f2a604&scoped=true"
import script from "./NewsListView.vue?vue&type=script&lang=js"
export * from "./NewsListView.vue?vue&type=script&lang=js"
import style0 from "./NewsListView.vue?vue&type=style&index=0&id=a0f2a604&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0f2a604",
  null
  
)

export default component.exports